import {useEffect, useState} from 'react'
import apiClient from 'src/services/apiClient'
import LoginPage from './LoginPage'
import LoginPageNew from 'src/pages-new/login/LoginPageNew'
import ThemeProviderNew from 'src/theme-new/ThemeProviderNew'

const LoginGate = () => {
  const [config, setConfig] = useState<any>()

  useEffect(() => {
    let mounted = true
    apiClient.loginConfiguration().then((res: any) => {
      if (mounted) setConfig(res)
    })
    return () => { mounted = false }
  }, [])

  if (!config) return null

  if (config.newStyleEnabled) {
    return (
      <ThemeProviderNew themeOverride={{primaryColor: config.primaryColor}}>
        <LoginPageNew config={config} />
      </ThemeProviderNew>
    )
  }

  return <LoginPage />
}

export default LoginGate
